import { Divider } from "@mui/material";

const DropdownDivider = () => {
  return <Divider sx={{ bgcolor: "rgba(0, 0, 0, 0.15)", margin: "8px 0" }} />;
};

export default DropdownDivider;
